import { render, staticRenderFns } from "./DefaultAboutProduct.vue?vue&type=template&id=aa1d1f20&scoped=true&"
import script from "./DefaultAboutProduct.vue?vue&type=script&lang=js&"
export * from "./DefaultAboutProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1d1f20",
  null
  
)

export default component.exports